import { useRef } from "react";
import { motion, useReducedMotion } from "framer-motion";

/**
 * Stable image reveal — NO parallax, NO translateY, NO layout shifts.
 * Only uses opacity for entrance → images never jump.
 * Container has fixed aspect-ratio so space is reserved before image loads.
 */
export default function RevealImage({
    src,
    alt,
    className = "",
    imgClassName = "",
    aspect = "aspect-[4/3]",
    priority = false,
    testid,
}) {
    const rm = useReducedMotion();
    const ref = useRef(null);

    const onMove = (e) => {
        const el = ref.current;
        if (!el) return;
        const r = el.getBoundingClientRect();
        el.style.setProperty("--mx", `${((e.clientX - r.left) / r.width) * 100}%`);
        el.style.setProperty("--my", `${((e.clientY - r.top) / r.height) * 100}%`);
    };

    return (
        <div
            ref={ref}
            className={`reveal-img overflow-hidden ${aspect} ${className}`}
            onMouseMove={onMove}
            data-testid={testid}
        >
            <motion.img
                src={src}
                alt={alt}
                loading={priority ? "eager" : "lazy"}
                decoding="async"
                fetchPriority={priority ? "high" : undefined}
                className={"w-full h-full object-cover " + imgClassName}
                initial={rm ? undefined : { opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true, margin: "-5% 0px" }}
                transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                style={{ willChange: "opacity" }}
            />
            <span className="sheen" aria-hidden="true" />
        </div>
    );
}
